import * as TabsPrimitive from '@radix-ui/react-tabs';
import type * as React from 'react';

import { cn, focusRing } from '@/lib/utils';

export const Tabs = TabsPrimitive.Root;

export function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn(
        // Scrolls sideways rather than overflowing the page when the tabs outgrow a phone.
        'inline-flex h-9 max-w-full items-center justify-start overflow-x-auto rounded-lg bg-secondary p-1 text-muted-foreground scrollbar-none',
        className,
      )}
      {...props}
    />
  );
}

export function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1 text-sm font-medium transition-all',
        focusRing,
        'hover:text-foreground disabled:pointer-events-none disabled:opacity-50',
        // The design system's segmented control: the selected segment is lifted.
        'data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:shadow-xs',
        className,
      )}
      {...props}
    />
  );
}

export function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn('mt-4 focus-visible:outline-none', className)}
      {...props}
    />
  );
}
